/**
 * Die vier Mahlzeiten des Tages - in TAGESFOLGE, nicht alphabetisch.
 * Alphabetisch stuende das Abendessen (dinner) vor dem Mittag (lunch).
 */
export const SLOTS = ['breakfast', 'lunch', 'dinner', 'snack'] as const
export type Slot = (typeof SLOTS)[number]

export const SLOT_NAME: Record<Slot, string> = {
  breakfast: 'Frühstück',
  lunch: 'Mittag',
  dinner: 'Abend',
  snack: 'Snack',
}

export function istSlot(wert: string): wert is Slot {
  return (SLOTS as readonly string[]).includes(wert)
}

export interface PlanEintrag {
  id: string
  onDate: string
  slot: string
  recipeId: string | null
  recipeTitle: string | null
  customTitle: string | null
  title: string
  notes: string | null
  servings: number | null
  visibility: string
  ownerMemberId: string | null
}

/** Eintraege je Tag und Mahlzeit, damit das Raster ohne Suche zeichnen kann. */
export function proTagUndSlot(
  eintraege: readonly PlanEintrag[],
): Map<string, Map<Slot, PlanEintrag[]>> {
  const karte = new Map<string, Map<Slot, PlanEintrag[]>>()
  for (const e of eintraege) {
    if (!istSlot(e.slot)) continue
    const tag = karte.get(e.onDate) ?? new Map<Slot, PlanEintrag[]>()
    const liste = tag.get(e.slot) ?? []
    liste.push(e)
    tag.set(e.slot, liste)
    karte.set(e.onDate, tag)
  }
  return karte
}

/** Was die Rueckmeldung nach einer Uebernahme sagt - ehrlich, auch bei 0. */
export function uebernahmeText(added: number, recipes?: number): string {
  const artikel = added === 1 ? '1 Artikel' : `${added} Artikel`
  if (recipes === undefined)
    return added === 0 ? 'Das Rezept hat keine Zutaten.' : `${artikel} auf die Liste gesetzt.`
  if (recipes === 0) return 'In dieser Woche ist kein Rezept eingeplant.'
  const rez = recipes === 1 ? '1 Rezept' : `${recipes} Rezepten`
  return `${artikel} aus ${rez} auf die Liste gesetzt.`
}
